<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="rpc_template_is_load" parent="rpc_template">
    <tab id="info" :name="translate('rpc_template.info')" :href="url+'/info'">
      <Info v-if="rpc_template_is_load"
        :rpc_template="rpc_template_info"
        @update="get_rpc_template"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              {{ translate('no_data') }}
            </h2>
            <router-link :to="{path:'/task_list/templates'}">
              {{ translate('task_list.templates.title') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Info.vue'

export default {
  name: 'RpcTemplate',
  components: {
    Info,
    Tab,
    Tabs,
  },
  data () {
    return {
      rpc_template_info: null,
      load: true,
    }
  },

  computed: {
    url () { return '/rpc_template/' + this.$route.params.rpc_template_id },
    cur_id () { return this.$route.params.rpc_template_id },
    rpc_template_is_load() { return this.rpc_template_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'rpc_template_section') {
        this.rpc_template_info = null
        this.get_rpc_template()
      }
    },
    rpc_template_info(){
      if (this.$route.name === 'rpc_template_section' && this.rpc_template_info) {
        this.$store.commit('updateOtherTitle', this.rpc_template_info.name)
      }
    }
  },

  activated(){
    this.get_rpc_template()
  },

  deactivated() {
    this.$store.commit('updateOtherTitle', '')
  },

  methods: {
    get_rpc_template () {
      let id = this.cur_id
      if (!id) return
      this.load = this.rpc_template_info === null
      this.$http.v1.getRPCTemplate(id, (response) => {
        if (id !== this.cur_id) return
        this.rpc_template_info = {
          ...response.data,
          visible: Number(response.data.visible) === 1,
          timeout: Number(response.data.timeout),
          clients: response.data.clients || [],
          client_ids: (response.data.clients || []).filter((client) => Number(client.active) === 1)
              .map((client) => Number(client.client_id))
        }
        this.load = false
      }, (error) => {
        if (id !== this.cur_id) return
        this.load = false
        this.bad_answer_handler(error)
      })
    }
  }
}
</script>
